export default "__VITE_ASSET__DIJbrsbD__"